import { render, staticRenderFns } from "./SoftwareComponentVersionList.vue?vue&type=template&id=764b6c50&"
import script from "./SoftwareComponentVersionList.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentVersionList.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentVersionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports